import { render } from "./OfertaWizard.vue?vue&type=template&id=6d088d09&scoped=true"
import script from "./OfertaWizard.vue?vue&type=script&lang=js"
export * from "./OfertaWizard.vue?vue&type=script&lang=js"

import "./OfertaWizard.vue?vue&type=style&index=0&id=6d088d09&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d088d09"]])

export default __exports__